export default {
	title: 'light',

	colors: {
		primary: '#457b9d',
		secondary: '#a8dadc',
		background: '#f1faee',
		text: '#333',
		headerText: '#FFF',
	},
};
